import React from "react";
import { t } from "i18next";

const TableEmptyIndicator = ({ message }) => {
  return (
    <div
      className="flex justify-center border-none items-center text-gray-500 font-semibold absolute left-0 bottom-0 right-0"
      style={{
        top: "52.4px",
      }}
    >
      {message ? message : t("_No_data_available")}
    </div>
  );
};

export default TableEmptyIndicator;
